import { useEffect } from 'react';
import { usePathname } from 'expo-router';

import {
  useIsLoggedIn,
  usePostLoginRedirectHref,
  useSendClearPostLoginRedirectHref,
} from '../../../context/AuthMachine';
import { useRedirectAfterAuthStateChange } from '../../../navigation';

// ─────────────────────────────────────────────────────────────────────────────

export const usePostLoginRedirect = () => {
  const isLoggedIn = useIsLoggedIn();
  const postLoginRedirectHref = usePostLoginRedirectHref();
  const sendClearPostLoginRedirectHref = useSendClearPostLoginRedirectHref();
  const redirectAfterAuthStateChange = useRedirectAfterAuthStateChange({
    shouldResetNavigation: true,
  });
  const pathname = usePathname();

  // ─── Effects ─────────────────────────────────────────────────────────

  useEffect(() => {
    if (!postLoginRedirectHref) return;

    // NOTE: Redirect once the customer has loaded, so the target screen doesn't load as a guest.
    if (!isLoggedIn) {
      return;
    }

    if (postLoginRedirectHref !== pathname) {
      redirectAfterAuthStateChange(postLoginRedirectHref);
    }

    sendClearPostLoginRedirectHref();
  }, [
    isLoggedIn,
    pathname,
    postLoginRedirectHref,
    redirectAfterAuthStateChange,
    sendClearPostLoginRedirectHref,
  ]);
};
